import { useContextWithValidation } from '@adsk/alloy-react-context';
import LocaleContext from '../context';
export default () => {
  const contextValue = useContextWithValidation(LocaleContext, {
    hook: 'useLocale',
    provider: 'LocaleProvider'
  });
  return {
    locale: contextValue === null || contextValue === void 0 ? void 0 : contextValue.locale,
    setLocale: contextValue === null || contextValue === void 0 ? void 0 : contextValue.setLocale
  };
};
//# sourceMappingURL=useOnlyLocale.js.map